var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"treatment-schedule-item",style:({ backgroundColor: _vm.currentItem.backgroundColor, color: _vm.currentItem.color, borderColor: _vm.currentItem.color })},[_c('span',[_vm._v(_vm._s(_vm.currentItem[_vm.labelName]))]),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }